import { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import {
  getSessionSetting,
  updateThemeSettings,
} from '../../services/apiService';
import * as loadingActions from '../../redux/reducers/loadingReducer';

const cardStyle = {
  backgroundColor: '#fff',
  borderRadius: 16,
  border: '1px solid rgba(0,0,0,0.07)',
  boxShadow: '0 1px 6px rgba(0,0,0,0.05)',
  overflow: 'hidden',
  marginBottom: 20,
};

const cardHeaderStyle = {
  display: 'flex',
  alignItems: 'center',
  padding: '14px 24px',
  borderBottom: '1px solid #F3F4F6',
};

const cardBodyStyle = {
  padding: '20px 24px',
};

const rowStyle = {
  display: 'grid',
  gridTemplateColumns: '1fr 200px',
  alignItems: 'center',
  gap: 16,
  marginBottom: 12,
};

const labelStyle = {
  fontSize: 13,
  fontWeight: 600,
  color: '#374151',
};

const inputStyle = {
  width: '100%',
  height: 36,
  backgroundColor: '#fff',
  border: '1px solid #E5E7EB',
  borderRadius: 4,
  padding: '0 10px',
  fontSize: 13,
  color: '#111827',
  outline: 'none',
  boxSizing: 'border-box',
  fontFamily: "'Gellix', 'Inter', sans-serif",
};

class SessionSettings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      themeSettings: [],
      generalSettings: {},
    };
  }

  fetchGeneralSessionSettings = async () => {
    const response = await getSessionSetting();
    this.setState({
      themeSettings: response.themeSettings,
      generalSettings: response.generalSettings,
    });
    this.props.setLoading(false);
  };

  componentDidMount() {
    loadingActions.setLoading(true);
    this.fetchGeneralSessionSettings();
  }

  updateSettingdata(data) {
    const { id } = data;
    const themeIndex = this.state.themeSettings.findIndex(
      (item) => item.id === id
    );
    const tempSettings = [...this.state.themeSettings];
    tempSettings[themeIndex] = {
      ...this.state.themeSettings[themeIndex],
      ...data,
    };
    this.setState({ themeSettings: tempSettings });
  }

  saveSettings = async () => {
    const payload = { themeSettings: this.state.themeSettings };
    if (Object.keys(this.state.generalSettings).length)
      payload.generalSettings = this.state.generalSettings;

    const resp = await updateThemeSettings(payload);
    if (resp) {
      toast.dark('  Settings Updated Successfully', {
        position: 'bottom-right',
        autoClose: 2200,
        pauseOnHover: true,
      });
    }
  };

  render() {
    return (
      <div>
        {/* Page header */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 24,
          }}
        >
          <div>
            <h1
              style={{
                fontSize: 22,
                fontWeight: 700,
                color: '#111827',
                margin: 0,
              }}
            >
              Session Settings
            </h1>
            <p
              style={{
                fontSize: 13,
                color: '#6B7280',
                marginTop: 4,
                marginBottom: 0,
              }}
            >
              Configure cancellation fines, time limits and wallet redemption
              rules
            </p>
          </div>
          <button
            onClick={this.saveSettings}
            style={{
              fontSize: 13,
              fontWeight: 600,
              color: '#fff',
              backgroundColor: '#4F46E5',
              border: 'none',
              borderRadius: 4,
              padding: '8px 20px',
              cursor: 'pointer',
              boxShadow: '0 2px 8px rgba(79,70,229,0.25)',
            }}
          >
            SAVE CHANGES
          </button>
        </div>

        {/* Card 1: Cancellation Fine */}
        <div style={cardStyle}>
          <div style={cardHeaderStyle}>
            <span style={{ fontSize: 14, fontWeight: 700, color: '#111827' }}>
              Coach Session Cancellation Fine
            </span>
          </div>
          <div style={cardBodyStyle}>
            {this.props.themes.map((theme, index) => (
              <div key={index} style={rowStyle}>
                <span style={labelStyle}>{theme.name}</span>
                <input
                  type='number'
                  style={inputStyle}
                  placeholder='₹'
                  defaultValue={theme.cancellationFine}
                  onChange={(e) =>
                    this.updateSettingdata({
                      cancellationFine: Number(e.target.value),
                      id: theme.id,
                    })
                  }
                />
              </div>
            ))}
          </div>
        </div>

        {/* Card 2: Cancellation Time */}
        <div style={cardStyle}>
          <div style={cardHeaderStyle}>
            <span style={{ fontSize: 14, fontWeight: 700, color: '#111827' }}>
              Coach Session Cancellation Time Before End Date
            </span>
          </div>
          <div style={cardBodyStyle}>
            {this.props.themes.map((theme, index) => (
              <div key={index} style={rowStyle}>
                <span style={labelStyle}>{theme.name}</span>
                <input
                  type='number'
                  style={inputStyle}
                  placeholder='hrs'
                  defaultValue={theme.cancellationTimeBeforeEndDate}
                  onChange={(e) =>
                    this.updateSettingdata({
                      cancellationTimeBeforeEndDate: Number(e.target.value),
                      id: theme.id,
                    })
                  }
                />
              </div>
            ))}
          </div>
        </div>

        {/* Card 3: General */}
        <div style={cardStyle}>
          <div style={cardHeaderStyle}>
            <span style={{ fontSize: 14, fontWeight: 700, color: '#111827' }}>
              General
            </span>
          </div>
          <div style={cardBodyStyle}>
            <div style={rowStyle}>
              <span style={labelStyle}>
                How much money coach can redeem per day from wallet
              </span>
              <input
                defaultValue={
                  this.state.generalSettings.maxRedeemLimitPerDay || ''
                }
                onChange={(e) =>
                  this.setState({
                    generalSettings: {
                      ...this.state.generalSettings,
                      maxRedeemLimitPerDay: Number(e.target.value),
                    },
                  })
                }
                type='number'
                style={inputStyle}
                placeholder='₹'
              />
            </div>
            <div style={{ ...rowStyle, marginBottom: 0 }}>
              <span style={labelStyle}>Minimum wallet redeem amount</span>
              <input
                defaultValue={
                  this.state.generalSettings.minRedeemAmount || ''
                }
                onChange={(e) =>
                  this.setState({
                    generalSettings: {
                      ...this.state.generalSettings,
                      minRedeemAmount: Number(e.target.value),
                    },
                  })
                }
                type='number'
                style={inputStyle}
                placeholder='₹'
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  themes: state.themeReducer.themes,
});

export default connect(mapStateToProps, loadingActions)(SessionSettings);
